export default "__VITE_ASSET__DcdRnHeo__"